//axios api
import api from "@/lib/Api";

export const getDepartmemts = async (viewAll) => {
  try {
    const queryRoute = `/itItem/departmemts?viewAll=${viewAll}`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getDepartmemtMember = async (departId) => {
  try {
    const queryRoute = `/itItem/departmemtMember?departId=${departId}`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getItItems = async () => {
  try {
    const queryRoute = `/itItem/itItems`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getItItemAccess = async () => {
  try {
    const queryRoute = `/itItem/itItemAccess`;
    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const updateItItemAccess = async (itItemAccess, department_id) => {
  try {
    const queryRoute = `/itItem/itItemAccess`;
    const reqBody = {
      itItemAccess,
      department_id,
    };
    const result = await api.axios.put(queryRoute, reqBody);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
